@if (dataLoading()) { <app-progress></app-progress> }

<div class="page-content">
  <div class="container-fluid">

    <!-- Breadcrumb -->
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-sm-flex align-items-center justify-content-between">
          <h4 class="mb-sm-0 font-size-18">{{ action().MenuTitle }}</h4>
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item">
                <a routerLink="/admin/admin-dashboard">Dashboard</a>
              </li>
              <li class="breadcrumb-item active">{{ action().ParentMenuTitle }}</li>
              <li class="breadcrumb-item">{{ action().MenuTitle }}</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <!-- ══════════════════════════════════════════════════════ -->
    <!-- FORM CARD                                              -->
    <!-- ══════════════════════════════════════════════════════ -->
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <span class="fw-semibold">
              {{ ActivityServiceModel.ActivityServiceId > 0 ? 'Update Activity Service' : 'Add Activity Service' }}
            </span>
            <br><br>

            <form #formActivityService="ngForm">
              <div class="row d-flex align-items-center">

                <!-- Destination -->
                <mat-form-field appearance="outline" class="col-sm-2">
                  <mat-label>Destination</mat-label>
                  <mat-select name="SelectedDestinationId"
                    [(ngModel)]="SelectedDestinationId"
                    (ngModelChange)="onFormDestinationChange()" required>
                    @for (dest of DestinationList(); track dest.DestinationId) {
                      <mat-option [value]="dest.DestinationId">{{ dest.DestinationName }}</mat-option>
                    }
                  </mat-select>
                  
                </mat-form-field>

                <!-- Location -->
                <mat-form-field appearance="outline" class="col-sm-2">
                  <mat-label>Location</mat-label>
                  <mat-select #LocationId="ngModel" name="LocationId"
                    [(ngModel)]="SelectedLocationId"
                    (ngModelChange)="onFormLocationChange()" required
                    [disabled]="LocationList().length === 0">
                    @for (loc of LocationList(); track loc.LocationId) {
                      <mat-option [value]="loc.LocationId">{{ loc.LocationName }}</mat-option>
                    }
                  </mat-select>
                  @if ((LocationId.dirty || LocationId.touched) || (LocationId.invalid && isSubmitted)) {
                    <mat-error>Location is <strong>required</strong></mat-error>
                  }
                  
                </mat-form-field>

                <!-- Activity Service Name -->
                <mat-form-field appearance="outline" class="col-sm-3">
                  <mat-label>Activity Service Name</mat-label>
                  <input matInput #ActivityServiceName="ngModel"
                    name="ActivityServiceName"
                    [(ngModel)]="ActivityServiceModel.ActivityServiceName"
                    required maxlength="150">
                  @if ((ActivityServiceName.dirty || ActivityServiceName.touched) || (ActivityServiceName.invalid && isSubmitted)) {
                    <mat-error>Activity Service Name is <strong>required</strong></mat-error>
                  }
                </mat-form-field>

                <!-- Service Type -->
                <mat-form-field appearance="outline" class="col-sm-2">
                  <mat-label>Service Type</mat-label>
                  <mat-select name="ServiceType"
                    [(ngModel)]="ActivityServiceModel.ServiceType">
                    <mat-option [value]="null">-- Select --</mat-option>
                    @for (type of ServiceTypeList; track type.Key) {
                      <mat-option [value]="type.Key">{{ type.Value }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>

                <!-- Status -->
                <mat-form-field appearance="outline" class="col-sm-1">
                  <mat-label>Status</mat-label>
                  <mat-select #Status="ngModel" name="Status"
                    [(ngModel)]="ActivityServiceModel.Status" required>
                    @for (status of StatusList; track status.Key) {
                      <mat-option [value]="status.Key">{{ status.Value }}</mat-option>
                    }
                  </mat-select>
                  @if ((Status.dirty || Status.touched) || (Status.invalid && isSubmitted)) {
                    <mat-error>Status is <strong>required</strong></mat-error>
                  }
                </mat-form-field>

                <!-- Save / Cancel Buttons -->
                <div class="col-sm-2 d-flex mb-4 align-items-center gap-2">
                  <button mat-raised-button color="primary" class="px-4" (click)="saveActivityService()">
                    <i class="bx bx-save me-1"></i>
                    {{ ActivityServiceModel.ActivityServiceId > 0 ? 'Update' : 'Save' }}
                  </button>
                  @if (ActivityServiceModel.ActivityServiceId > 0) {
                    <button mat-raised-button color="warn" (click)="resetForm()">
                      Cancel
                    </button>
                  }
                </div>

              </div>
            </form>

          </div>
        </div>
      </div>
    </div>

    <!-- ══════════════════════════════════════════════════════ -->
    <!-- FILTER + LIST CARD                                     -->
    <!-- ══════════════════════════════════════════════════════ -->
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">

            <!-- Filter Row -->
            <div class="row d-flex align-items-center mb-3">

              <!-- Filter Destination -->
              <mat-form-field appearance="outline" class="col-sm-3">
                <mat-label>Destination</mat-label>
                <mat-select name="FilterDestinationId"
                  [(ngModel)]="FilterDestinationId"
                  (ngModelChange)="onFilterDestinationChange()">
                  <mat-option [value]="0">-- Select Destination --</mat-option>
                  @for (dest of DestinationList(); track dest.DestinationId) {
                    <mat-option [value]="dest.DestinationId">{{ dest.DestinationName }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>

              <!-- Filter Location -->
              <mat-form-field appearance="outline" class="col-sm-3">
                <mat-label>Location</mat-label>
                <mat-select name="FilterLocationId"
                  [(ngModel)]="FilterLocationId"
                  (ngModelChange)="onFilterLocationChange()"
                  [disabled]="FilterLocationList().length === 0">
                  <mat-option [value]="0">-- Select Location --</mat-option>
                  @for (loc of FilterLocationList(); track loc.LocationId) {
                    <mat-option [value]="loc.LocationId">{{ loc.LocationName }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>

            </div>

            @if (!FilterLocationId || FilterLocationId == 0) {
              <div class="text-center py-4 text-muted">
                <i class="bx bx-map-pin fs-1 d-block mb-2 opacity-25"></i>
                <p class="mb-0">Select Destination → Location to view activity services.</p>
              </div>
            }

            @if (FilterLocationId && FilterLocationId != 0) {

              <!-- Show entries + Search -->
              <div class="row mb-3">
                <div class="col-md-4">
                  <div class="dataTables_length">
                    <label>Show
                      <select class="form-select form-select-sm d-inline-block w-auto"
                        [(ngModel)]="itemPerPage">
                        @for (option of PageSize; track option) {
                          <option [value]="option">{{ option }}</option>
                        }
                      </select> entries
                    </label>
                  </div>
                </div>
                <div class="col-md-4 ms-auto">
                  <div class="dataTables_filter d-flex justify-content-end">
                    <label>Search:
                      <input type="search"
                        class="form-control form-control-sm d-inline-block w-auto ms-1"
                        [(ngModel)]="Search">
                    </label>
                  </div>
                </div>
              </div>

              <div class="table-responsive">
                <table class="table table-bordered table-hover align-middle" style="font-size:13.5px;">
                  <thead class="table-light">
                    <tr>
                      <th>S.No</th>
                      <th style="cursor:pointer" (click)="sort('LocationName')">
                          Location <i class="bx bx-sort ms-1"></i>
                        </th>
                        <th style="cursor:pointer" (click)="sort('ActivityServiceName')">
                          Activity Service Name <i class="bx bx-sort ms-1"></i>
                        </th>
                      <th style="cursor:pointer" (click)="sort('ServiceType')">
                        Service Type <i class="bx bx-sort ms-1"></i>
                      </th>
                      <th style="cursor:pointer" (click)="sort('Status')">
                        Status <i class="bx bx-sort ms-1"></i>
                      </th>
                      @if (action().CanEdit)   { <th class="text-center">Edit</th> }
                      @if (action().CanDelete) { <th class="text-center">Delete</th> }
                    </tr>
                  </thead>
                  <tbody>
                    @for (
                      item of ActivityServiceList()
                        | filter: Search
                        | orderBy: sortKey : reverse
                        | paginate: { itemsPerPage: itemPerPage, currentPage: p };
                      track item.ActivityServiceId;
                      let i = $index
                    ) {
                      <tr>
                        <td class="text-muted">{{ (itemPerPage * (p - 1)) + i + 1 }}</td>
                        <td>{{ item.LocationName }}</td>
                        <td class="fw-semibold">{{ item.ActivityServiceName }}</td>
                        <td>{{ item.ServiceType != null ? ServiceTypeList.find(type => type.Key === item.ServiceType)?.Value : '—' }}</td>
                        <td>
                          <span class="badge"
                            [class.bg-success]="item.Status === 1"
                            [class.bg-danger]="item.Status !== 1">
                            {{ AllStatusList[item.Status] }}
                          </span>
                        </td>
                        @if (action().CanEdit) {
                          <td class="text-center">
                            <a class="text-success" style="cursor:pointer"
                              (click)="editActivityService(item)">
                              <i class="bx bxs-edit-alt fs-5"></i>
                            </a>
                          </td>
                        }
                        @if (action().CanDelete) {
                          <td class="text-center">
                            <a class="text-danger" style="cursor:pointer"
                              (click)="deleteActivityService(item)">
                              <i class="bx bxs-trash fs-5"></i>
                            </a>
                          </td>
                        }
                      </tr>
                    }
                    @if (ActivityServiceList().length === 0 && !dataLoading()) {
                      <tr>
                        <td colspan="7" class="text-center text-muted py-4">
                          <i class="bx bx-file-blank fs-1 d-block mb-2"></i>
                          No records found
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>

              <pagination-controls (pageChange)="onTableDataChange($event)"
                class="my-pagination" style="float:right;">
              </pagination-controls>

            }

          </div>
        </div>
      </div>
    </div>

  </div>
</div>